// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__rOMnS","item":"Menu_item__jfaZL","btnWrapper":"Menu_btnWrapper__Ww3aw","button":"Menu_button__AYwvA","separate":"Menu_separate__AkJAz"};